module.exports = __webpack_public_path__ + "static/img/iphone1.e59dafa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone1.png
// module id = 6afi
// module chunks = 0